import { takeLatest, put, call } from 'redux-saga/effects';
import { CORE_API,REPORT } from '../../../config';
import * as CorporateListAction from './Action';
import * as GetReportByAction from './Action';
import request from '../../../components/Utils/httpHelper';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
const token = localStorage.getItem('id_token');
const httpHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`
}



export function* getMeteringCorporateDetailsList(action) {
    let requestUrl = `${CORE_API}/corporate/filtermodel/list`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', data: '', headers: httpHeaders });
        yield put(CorporateListAction.listCorporateSuccess(createResult.data));
    } catch (err) {
        if (!err.response) {
            yield put(CorporateListAction.listCorporateFailure(false))
        } else {
            yield put(CorporateListAction.listCorporateFailure(err))
        }

    }
}
export function* getMeteringCorporateList(action) {
    yield takeLatest(CorporateListAction.LIST_CORPORATE, getMeteringCorporateDetailsList);
}

export function* getReportByDate(action) {
    let corporateId = action.data.corporateId;
    let startDate = action.data.startDate;
    let endDate = action.data.endDate;

const queryParams = new URLSearchParams({
  corporateId: corporateId,
  startDate: startDate,
  endDate: endDate,
});

let requestUrl = `${CORE_API}/metering/transactions/export-to-excel?${queryParams.toString()}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', data: '', headers: httpHeaders, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  });
        yield put(GetReportByAction.reportByDateSuccess(createResult.data));
    } catch (err) {
        if (!err.response) {
            yield put(GetReportByAction.reportByDateFailure(false))
        } else {
            yield put(GetReportByAction.reportByDateFailure(err))
        }

    }
}
export function* getReportByDates(action) {
    yield takeLatest(GetReportByAction.REPORT_BY_DATE, getReportByDate);
}